"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMEDY_APPLIED_TEXT_CLASS = exports.DOCUMENT_WORDS_SUPERSESSION = void 0;
exports.RemedyActions = RemedyActions;
exports.RemedyAppliedIndicator = RemedyAppliedIndicator;
exports.RemedyApplyButton = void 0;
exports.RemedyDismissButton = RemedyDismissButton;
exports.RemedyDismissedIndicator = RemedyDismissedIndicator;
exports.RemedyDriftWarning = RemedyDriftWarning;
exports.RemedyFailedIndicator = RemedyFailedIndicator;
exports.RemedyGoToIssueButton = RemedyGoToIssueButton;
exports.RemedyHeldBackIndicator = RemedyHeldBackIndicator;
exports.RemedyIconOrSpinner = RemedyIconOrSpinner;
exports.RemedyPartlyAppliedIndicator = RemedyPartlyAppliedIndicator;
exports.RemedyPotentialCollisionIndicator = RemedyPotentialCollisionIndicator;
exports.RemedyRegenerateIcon = RemedyRegenerateIcon;
exports.RemedyStepNavigation = RemedyStepNavigation;
exports.RemedySupersededIndicator = RemedySupersededIndicator;
var _react = _interopRequireDefault(require("react"));
var _hoverCard = require("@design/ui/hover-card");
var _button = require("@design/ui/button");
var _spinner = require("@design/ui/spinner");
var _materialSymbols = require("@design/icons/material-symbols");
var _utils = require("@design/lib/utils");
var _cardCollisions = require("@common/utils/redline/text/card-collisions");
var _collisionWording = require("./collision-wording");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["$isRegenerating", "className"],
  _excluded2 = ["isLoading", "label", "showIcon", "disabled"],
  _excluded3 = ["isSaving", "disabled"],
  _excluded4 = ["isSaving", "disabled"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function RemedyRegenerateIcon(_ref) {
  var $isRegenerating = _ref.$isRegenerating,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", _objectSpread(_objectSpread({}, rest), {}, {
    className: (0, _utils.cn)("transition-opacity duration-200 ease-in", $isRegenerating && "animate-remedy-pulse", className),
    "data-sentry-component": "RemedyRegenerateIcon",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx"
  }));
}
var RemedyApplyButton = exports.RemedyApplyButton = /*#__PURE__*/_react.default.forwardRef(function RemedyApplyButton(_ref2, ref) {
  var isLoading = _ref2.isLoading,
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Apply" : _ref2$label,
    _ref2$showIcon = _ref2.showIcon,
    showIcon = _ref2$showIcon === void 0 ? true : _ref2$showIcon,
    disabled = _ref2.disabled,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({
    type: "button",
    size: "xs",
    ref: ref
  }, rest), {}, {
    disabled: Boolean(isLoading || disabled),
    "aria-busy": isLoading || undefined,
    children: [isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
      "data-icon": "inline-start",
      "aria-hidden": "true"
    }) : showIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
      "data-icon": "inline-start"
    }), label]
  }));
});
function RemedyGoToIssueButton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    type: "button",
    variant: "outline",
    size: "xs"
  }, props), {}, {
    "data-sentry-element": "Button",
    "data-sentry-component": "RemedyGoToIssueButton",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx"
  }));
}
function RemedyIconOrSpinner(_ref3) {
  var isSaving = _ref3.isSaving,
    Icon = _ref3.icon,
    size = _ref3.size,
    className = _ref3.className;
  return isSaving ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
    style: {
      width: size,
      height: size
    },
    className: className,
    "aria-hidden": "true",
    "data-sentry-element": "Spinner",
    "data-sentry-component": "RemedyIconOrSpinner",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx"
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
    width: size,
    height: size,
    className: className,
    "data-sentry-element": "Icon",
    "data-sentry-component": "RemedyIconOrSpinner",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx"
  });
}
function RemedyDismissButton(_ref4) {
  var isSaving = _ref4.isSaving,
    disabled = _ref4.disabled,
    props = _objectWithoutProperties(_ref4, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    type: "button",
    variant: "ghost",
    size: "icon-xs",
    "aria-label": "Dismiss",
    title: "Dismiss"
  }, props), {}, {
    disabled: isSaving || disabled,
    "aria-busy": isSaving || undefined,
    "data-sentry-element": "Button",
    "data-sentry-component": "RemedyDismissButton",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: isSaving ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
      "aria-hidden": "true"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {})
  }));
}
function RemedyDismissedIndicator(_ref5) {
  var isSaving = _ref5.isSaving,
    disabled = _ref5.disabled,
    props = _objectWithoutProperties(_ref5, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1",
    "data-sentry-component": "RemedyDismissedIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "text-caption text-muted-foreground font-medium",
      children: "Dismissed"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "aria-label": "Undo dismiss",
      title: "Undo dismiss"
    }, props), {}, {
      disabled: isSaving || disabled,
      "aria-busy": isSaving || undefined,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx",
      children: isSaving ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
        "aria-hidden": "true"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UndoIcon, {})
    }))]
  });
}
var REMEDY_APPLIED_TEXT_CLASS = exports.REMEDY_APPLIED_TEXT_CLASS = "text-success-text";
function RemedyAppliedIndicator() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1 text-caption ".concat(REMEDY_APPLIED_TEXT_CLASS, " font-medium"),
    "data-sentry-component": "RemedyAppliedIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      width: 14,
      height: 14,
      className: REMEDY_APPLIED_TEXT_CLASS,
      "data-sentry-element": "CheckIcon",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx"
    }), "Applied"]
  });
}
function RemedyHeldBackIndicator(_ref6) {
  var heldBackReason = _ref6.heldBackReason;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "status",
    className: "flex flex-shrink-0 items-center gap-1 text-caption text-warning-text font-medium",
    "data-sentry-component": "RemedyHeldBackIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 14,
      height: 14,
      className: "flex-shrink-0 text-warning-text",
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx"
    }), heldBackReason]
  });
}
var DOCUMENT_WORDS_SUPERSESSION = exports.DOCUMENT_WORDS_SUPERSESSION = "the words already in the document";
function RemedySupersededIndicator(_ref7) {
  var supersededBy = _ref7.supersededBy,
    onShowSuperseder = _ref7.onShowSuperseder;
  var superseder = onShowSuperseder ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    variant: "link",
    onClick: function onClick(e) {
      e.stopPropagation();
      onShowSuperseder();
    },
    className: "h-auto p-0 text-caption font-medium ".concat(REMEDY_APPLIED_TEXT_CLASS),
    children: supersededBy
  }) : supersededBy;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-1 text-caption ".concat(REMEDY_APPLIED_TEXT_CLASS, " font-medium"),
    "data-sentry-component": "RemedySupersededIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
      width: 14,
      height: 14,
      className: REMEDY_APPLIED_TEXT_CLASS,
      "data-sentry-element": "CheckIcon",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx"
    }), "Superseded by ", superseder]
  });
}
var NO_CONFLICTING_CARDS = [];
function RemedyFailedIndicator(_ref8) {
  var reason = _ref8.reason,
    _ref8$conflictingCard = _ref8.conflictingCards,
    conflictingCards = _ref8$conflictingCard === void 0 ? NO_CONFLICTING_CARDS : _ref8$conflictingCard,
    _ref8$partlyApplied = _ref8.partlyApplied,
    partlyApplied = _ref8$partlyApplied === void 0 ? false : _ref8$partlyApplied;
  var label = partlyApplied ? "Partly applied" : "Failed to apply";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    title: reason,
    "aria-label": "".concat(label, ": ").concat(reason),
    className: "flex flex-shrink-0 items-center gap-1 text-caption text-destructive-text font-medium cursor-help",
    "data-sentry-component": "RemedyFailedIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 14,
      height: 14,
      className: "text-destructive-text",
      "data-sentry-element": "WarningIcon",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx"
    }), label, conflictingCards.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "ml-1",
      children: ["Conflicts with", " ", conflictingCards.map(function (card, position) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
          children: [position > 0 && ", ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "link",
            onClick: function onClick(e) {
              e.stopPropagation();
              card.onShow();
            },
            className: "h-auto p-0 text-caption text-destructive-text font-medium",
            children: card.label
          })]
        }, card.id);
      })]
    })]
  });
}
function CollisionCardButton(_ref9) {
  var collision = _ref9.collision,
    className = _ref9.className;
  var button = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
    type: "button",
    variant: "link",
    onClick: function onClick(e) {
      e.stopPropagation();
      collision.onShow();
    },
    className: (0, _utils.cn)("h-auto px-1.5 py-0.5 -mx-0.5 rounded hover:bg-warning-bg-hover text-caption font-medium", className),
    children: ["#", collision.number]
  });
  if (collision.otherChange === null) return button;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_hoverCard.HoverCard, {
    openDelay: 0,
    "data-sentry-element": "HoverCard",
    "data-sentry-component": "CollisionCardButton",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverCard.HoverCardTrigger, {
      asChild: true,
      "data-sentry-element": "HoverCardTrigger",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx",
      children: button
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_hoverCard.HoverCardContent, {
      align: "start",
      className: "flex flex-col gap-1 p-2",
      "data-sentry-element": "HoverCardContent",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "text-xs font-medium text-muted-foreground",
        children: ["#", collision.number, " changes"]
      }), collision.otherChange]
    })]
  });
}
function collisionLinkGroupsOf(collisions) {
  var groups = [];
  var _iterator = _createForOfIteratorHelper(collisions),
    _step;
  try {
    var _loop = function _loop() {
      var collision = _step.value;
      var group = groups.find(function (candidate) {
        return candidate.proximity === collision.proximity && candidate.alsoMakesSameChange === collision.alsoMakesSameChange;
      });
      if (group) group.links.push(collision);else groups.push({
        proximity: collision.proximity,
        alsoMakesSameChange: collision.alsoMakesSameChange,
        links: [collision]
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return groups;
}
function renderLinkedCardNumbers(links, className) {
  return links.map(function (link, position) {
    var separator = position === 0 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: position === links.length - 1 ? " & " : ", "
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
      children: [separator, /*#__PURE__*/(0, _jsxRuntime.jsx)(CollisionCardButton, {
        collision: link,
        className: className
      })]
    }, link.number);
  });
}
function RemedyPotentialCollisionIndicator(_ref0) {
  var collisions = _ref0.collisions;
  var conflictGroups = collisionLinkGroupsOf(collisions.filter(function (collision) {
    return (0, _cardCollisions.proximityNeedsChoice)(collision.proximity);
  }));
  var noteGroups = collisionLinkGroupsOf(collisions.filter(function (collision) {
    return !(0, _cardCollisions.proximityNeedsChoice)(collision.proximity);
  }));
  if (collisions.length === 0) return null;
  var conflictLine = conflictGroups.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-wrap items-center gap-x-0.5 text-caption text-warning-text font-medium",
    "aria-label": "May conflict with other cards",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.WarningIcon, {
      width: 14,
      height: 14,
      className: "text-warning-strong mr-0.5"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      children: ["May conflict with", " "]
    }), conflictGroups.map(function (group, position) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
        children: [position > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: [";", " "]
        }), renderLinkedCardNumbers(group.links, "text-warning-text"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "text-warning-text",
          children: [" ", "(", (0, _collisionWording.conflictLabelOf)(group.proximity), group.alsoMakesSameChange ? "; ".concat(_collisionWording.SAME_CHANGE_NOTE) : "", ")"]
        })]
      }, "".concat(group.proximity, "-").concat(group.alsoMakesSameChange));
    })]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-0.5",
    "data-sentry-component": "RemedyPotentialCollisionIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [conflictLine, noteGroups.map(function (group) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-wrap items-center gap-x-0.5 text-caption text-muted-foreground",
        "aria-label": "Related card",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.InfoIcon, {
          width: 13,
          height: 13,
          className: "text-muted-foreground mr-0.5"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: [(0, _collisionWording.infoPrefixOf)(group.proximity), " "]
        }), renderLinkedCardNumbers(group.links, "text-muted-foreground"), group.alsoMakesSameChange && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          children: [" ", "\xB7 ", _collisionWording.SAME_CHANGE_NOTE]
        })]
      }, "".concat(group.proximity, "-").concat(group.alsoMakesSameChange));
    })]
  });
}
function RemedyPartlyAppliedIndicator(_ref1) {
  var reason = _ref1.reason;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex min-w-0 flex-col gap-0.5",
    "data-sentry-component": "RemedyPartlyAppliedIndicator",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(RemedyFailedIndicator, {
      reason: reason,
      partlyApplied: true,
      "data-sentry-element": "RemedyFailedIndicator",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "status",
      className: "text-caption text-destructive-text",
      children: reason
    })]
  });
}
function RemedyActions(_ref10) {
  var onApply = _ref10.onApply,
    isApplying = _ref10.isApplying,
    isActionApplied = _ref10.isActionApplied,
    onActionApplied = _ref10.onActionApplied,
    isActionDismissed = _ref10.isActionDismissed,
    isDismissalSaving = _ref10.isDismissalSaving,
    onActionDismissed = _ref10.onActionDismissed,
    onActionUndismissed = _ref10.onActionUndismissed,
    applyFailure = _ref10.applyFailure;
  function renderStatus() {
    if (isActionDismissed) {
      return onActionUndismissed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(RemedyDismissedIndicator, {
        onClick: function onClick(e) {
          e.stopPropagation();
          onActionUndismissed();
        },
        isSaving: isDismissalSaving
      }) : null;
    }
    if (applyFailure) return /*#__PURE__*/(0, _jsxRuntime.jsx)(RemedyFailedIndicator, {
      reason: applyFailure
    });
    if (isActionApplied) return /*#__PURE__*/(0, _jsxRuntime.jsx)(RemedyAppliedIndicator, {});
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [!isActionApplied && !isActionDismissed && onActionApplied && /*#__PURE__*/(0, _jsxRuntime.jsx)(RemedyApplyButton, {
      onClick: onApply,
      isLoading: isApplying
    }), !isActionApplied && !isActionDismissed && onActionDismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)(RemedyDismissButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onActionDismissed();
      },
      isSaving: isDismissalSaving
    }), renderStatus()]
  });
}
function RemedyDriftWarning(_ref11) {
  var children = _ref11.children,
    className = _ref11.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _utils.cn)("mt-1.5 py-1.5 px-2 bg-warning-bg border border-warning-border rounded text-caption text-warning-text flex items-start gap-2", className),
    "data-sentry-component": "RemedyDriftWarning",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: children
  });
}
function RemedyStepNavigation(_ref12) {
  var currentStepIndex = _ref12.currentStepIndex,
    totalSteps = _ref12.totalSteps,
    onPrev = _ref12.onPrev,
    onNext = _ref12.onNext;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-0 mb-2",
    "data-sentry-component": "RemedyStepNavigation",
    "data-sentry-source-file": "RemedyActionPrimitives.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "aria-label": "Previous step",
      onClick: function onClick(e) {
        e.stopPropagation();
        onPrev();
      },
      disabled: currentStepIndex === 0,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {
        "data-sentry-element": "ChevronLeftIcon",
        "data-sentry-source-file": "RemedyActionPrimitives.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "font-sans font-normal text-sm text-muted-foreground min-w-[40px] text-center px-1",
      children: [currentStepIndex + 1, "/", totalSteps]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "aria-label": "Next step",
      onClick: function onClick(e) {
        e.stopPropagation();
        onNext();
      },
      disabled: currentStepIndex === totalSteps - 1,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "RemedyActionPrimitives.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
        "data-sentry-element": "ChevronRightIcon",
        "data-sentry-source-file": "RemedyActionPrimitives.tsx"
      })
    })]
  });
}